import { useState, useEffect } from 'react';

function useContainerWidth(ref) {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (ref.current) {
            const resizeObserver = new ResizeObserver(entries => {
                if (entries[0].target) {
                    const { width } = entries[0].contentRect;
                    setWidth(width);
                }
            });
            resizeObserver.observe(ref.current);

            return () => {
                if (ref.current) {
                    resizeObserver.unobserve(ref.current);
                }
            };
        }
    }, [ref]);
    return width;
}

export default useContainerWidth;